// extracted by mini-css-extract-plugin
module.exports = {"card":"card--3kXSk","title":"title--2qJcX","name":"name--2B5My","border":"border--5zdDm","cardBody":"cardBody--2IwFP"};